<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
	<div>
		<textarea
				:id="id"
				:cols="columns"
				:disabled="disabled"
				:maxlength="maxlength"
				:name="name"
				:placeholder="placeholder"
				:readonly="readonly"
				:rows="rows"
				:spellcheck="`${spellcheck ? 'true' : 'false'}`"
				:value="modelValue"
				class="input-element"
				v-bind="$attrs"
				@blur="emitValue($event, true)"
				@input="emitValue($event, false)"
		></textarea>
	</div>
</template>

<script lang="ts" setup>
	import {
		formTextareaProps,
		sharedFormElementProps,
		sharedFormInputProps
	} from '~/components/forms/sharedFormInputProps';

	const props = defineProps({
		...sharedFormElementProps,
		...sharedFormInputProps,
		...formTextareaProps
	});
	defineOptions({
		inheritAttrs: false
	});

	const emit = defineEmits(['update:modelValue']);

	/**
	 * Emit the value of the textarea element
	 * @param e The event that triggered the function
	 * @param trim Whether to trim the value before emitting
	 */
	const emitValue = (e: Event, trim = false) => {
		let value: string | null = (e.target as HTMLTextAreaElement).value;

		if (trim) {
			value = value.trim();
		}

		if (props.nullIfEmpty && value.trim() === '') {
			value = null;
		}

		emit('update:modelValue', value);
	};
</script>

<style scoped>
	div {
		width: 100%;
		overflow: auto;
	}

	textarea {
		--rows: v-bind(rows)
	}
</style>
